import * as CubeTree from '../cubeTree/index';
import { updateEnd } from './updateEnd';

// 暂时只考虑商品
function runForceUpdate(cubeIds: Array<CubeId>): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        cube.update(/* 强制更新 */true);
    });
    updateEnd();
}

export {
    runForceUpdate
};
